import { soFetch } from 'so-fetch';
import checkStatus from '../../utils/checkStatus.js';
import * as constants from './connections-constants';

const credentialsAndHeaders = {
  credentials: 'same-origin',
  headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
};

const baseUrl = '/proxy/connections';
const put = Object.assign({ method: 'put' }, credentialsAndHeaders);
const del = Object.assign({ method: 'delete' }, credentialsAndHeaders);

function ignoreConnectionStarting(connectionId) {
  return {
    type: constants.IGNORE_CONNECTION_STARTING,
    payload: connectionId,
  };
}

function acceptConnectionStarting(connectionId) {
  return {
    type: constants.ACCEPT_CONNECTION_STARTING,
    payload: connectionId,
  };
}


function resendConnectionStarting(connectionId) {
  return {
    type: constants.RESEND_CONNECTION_STARTING,
    payload: connectionId,
  };
}

function removeConnectionStarting(connectionId) {
  return {
    type: constants.REMOVE_CONNECTION_STARTING,
    payload: connectionId,
  };
}

function addTagStarting(connectionId, tagName) {
  return {
    type: constants.ADD_TAG_STARTING,
    payload: {
      tagName,
      connectionId,
    },
  };
}

function removeTagStarting(connectionId, tagName) {
  return {
    type: constants.REMOVE_TAG_STARTING,
    payload: {
      tagName,
      connectionId,
    },
  };
}

export function isSyncing() {
  return {
    type: constants.CONNECTIONS_IS_SYNCING,
  };
}

export function filterConnections(options, pagination) {
  return dispatch => {
    dispatch(isSyncing());
    return soFetch(baseUrl, {
      actionType: pagination ? constants.LOAD_MORE_CONNECTIONS : constants.FILTER_CONNECTIONS,
      responseBinding: 'payload',
      qs: options,
    })(dispatch);
  };
}

export function filterConnectionsByCountry(options) {
  return dispatch => {
    dispatch(isSyncing());
    return soFetch(baseUrl, {
      actionType: constants.FILTER_CONNECTIONS_BY_COUNTRY,
      responseBinding: 'payload',
      qs: options,
    })(dispatch);
  };
}

export function getCountries() {
  return soFetch(`${baseUrl}/countries`, {
    actionType: constants.GET_COUNTRIES,
    responseBinding: 'payload',
  });
}

export function undoConnectionChange(isToUndoRemoveConnection) {
  return dispatch => {
    if (isToUndoRemoveConnection) {
      return fetch(baseUrl, put)
      .then(checkStatus)
      .then(res => res.json())
      .then(() => dispatch({
        type: constants.UNDO_CONNECTION_CHANGE,
      }))
      .catch(err => {
        throw new Error(err);
      });
    }
    return {
      type: constants.UNDO_CONNECTION_CHANGE,
    };
  };
}

export function ignoreConnection(connectionId) {
  return dispatch => {
    dispatch(ignoreConnectionStarting(connectionId));
    return fetch(`/proxy/connections/${connectionId}/rejected`, put)
    .then(checkStatus)
    .then(res => res.json())
    .then(res => dispatch({
      type: constants.IGNORE_CONNECTION,
      payload: res,
    }))
    .catch(err => {
      console.log(err);
      return dispatch(undoConnectionChange());
    });
  };
}

export function removeConnection(connectionId) {
  return dispatch => {
    dispatch(removeConnectionStarting(connectionId));
    return fetch(`/proxy/connections/${connectionId}/archive`, put)
    .then(checkStatus)
    .then(res => res.json())
    .then(res => dispatch({
      type: constants.REMOVE_CONNECTION,
      payload: res,
    }))
    .catch(err => {
      console.log(err);
      return dispatch(undoConnectionChange());
    });
  };
}

export const acceptConnection = (connectionId) => dispatch => {
  dispatch(acceptConnectionStarting(connectionId));
  return fetch(`/proxy/connections/${connectionId}/accepted`, put)
  .then(checkStatus)
  .then(res => res.json())
  .then(res => dispatch({
    type: constants.ACCEPT_CONNECTION,
    payload: res,
  }))
  .catch(err => {
    console.log(err);
    return dispatch(undoConnectionChange());
  });
};

export function resendConnection(connectionId) {
  return dispatch => {
    dispatch(resendConnectionStarting(connectionId));
    return fetch(`/proxy/connections/${connectionId}/resend`, put)
    .then(checkStatus)
    .then(res => res.json())
    .then(res => dispatch({
      type: constants.RESEND_CONNECTION,
      payload: res,
    }))
    .catch(err => {
      console.log(err);
      throw new Error(err);
    });
  };
}


export function removeTag(connectionId, tagName) {
  return dispatch => {
    dispatch(removeTagStarting(connectionId, tagName));
    return fetch(`/proxy/connections/${connectionId}/tag/${encodeURIComponent(tagName)}`, del)
    .then(checkStatus)
    .then(res => res.json())
    .then(res => dispatch({
      type: constants.REMOVE_TAG,
      payload: res,
    }))
    .catch(err => {
      console.log(err);
      throw new Error(err);
    });
  };
}

export function addTag(connectionId, tagName) {
  return dispatch => {
    dispatch(addTagStarting(connectionId, tagName));
    return fetch(`/proxy/connections/${connectionId}/tag/${encodeURIComponent(tagName)}`, put)
    .then(checkStatus)
    .then(res => res.json())
    .then(res => {
      return dispatch({
        type: constants.ADD_TAG,
        payload: res,
      });
    })
    .catch(err => {
      console.log(err);
      throw new Error(err);
    });
  };
}



// WEBPACK FOOTER //
// ./src/app/stores/connections/connections-actions.js